{
  "en": {
    "pinboard": {
      "activity": {
        "board": {
          "addAttachment": "<strong>{user}</strong> added the attachment <a href=\"{url}\" target=\"_blank\">{value}</a> to the card <a href=\"{cardUrl}\">{cardName}</a>",
          "addAttachmentAfterRemoval": "<strong>{user}</strong> added the attachment {value} to the card <a href=\"{cardUrl}\">{cardName}</a>",
          "createCard": "<strong>{user}</strong> has created the card <a href=\"{cardUrl}\">{cardName}</a>",
          "destroyCard": "<strong>{user}</strong> has deleted the card {cardName}",
          "moveCard": "<strong>{user}</strong> moved the card <a href=\"{cardUrl}\">{cardName}</a> from <em>{oldValue}</em> to <em>{value}</em>",
          "removeAttachment": "<strong>{user}</strong> removed the attachment <em>{oldValue}</em> from the card <a href=\"{cardUrl}\">{cardName}</a>",
          "updateCardColor": "<strong>{user}</strong> changed the color of the card <a href=\"{cardUrl}\">{cardName}</a>",
          "updateCardCoverImage": "<strong>{user}</strong> changed the cover image of the card <a href=\"{cardUrl}\">{cardName}</a> to <a href=\"{url}\" target=\"_blank\">{value}</a>",
          "updateCardDescription": "<strong>{user}</strong> changed the description of the card <a href=\"{cardUrl}\">{cardName}</a>",
          "updateCardName": "<strong>{user}</strong> changed the title of the card <a href=\"{cardUrl}\">{cardName}</a> (from: <em>{oldValue}</em>)",
          "updateCardVisitorPermissions": "<strong>{user}</strong> changed the visitor permissions of the card <a href=\"{cardUrl}\">{cardName}</a> (from: <em>{oldValue}</em> to: <em>{value}</em>)"
        },
        "card": {
          "addAttachment": "<strong>{user}</strong> added the attachment <a href=\"{url}\" target=\"_blank\">{value}</a>",
          "addAttachmentAfterRemoval": "<strong>{user}</strong> added the attachment {value}",
          "createCard": "<strong>{user}</strong> has created this card",
          "moveCard": "<strong>{user}</strong> moved this card from <em>{oldValue}</em> to <em>{value}</em>",
          "removeAttachment": "<strong>{user}</strong> removed the attachment <em>{oldValue}</em>",
          "updateCardColor": "<strong>{user}</strong> changed the color",
          "updateCardCoverImage": "<strong>{user}</strong> set the cover image to <a href=\"{url}\" target=\"_blank\">{value}</a>",
          "updateCardDescription": "<strong>{user}</strong> changed the description",
          "updateCardName": "<strong>{user}</strong> changed the title (from: <em>{oldValue}</em>)",
          "updateCardVisitorPermissions": "<strong>{user}</strong> changed the visitor permissions of the card (from: <em>{oldValue}</em> to: <em>{value}</em>)"
        },
        "missingUser": "Deleted user"
      },
      "buttons": {
        "addAttachment": "Add attachment",
        "addCard": "Add Card",
        "addList": "Add List",
        "color": "Color",
        "create": "Create",
        "loadMore": "Load more",
        "openListSettings": "Open list settings"
      },
      "card": {
        "openFile": "Open file",
        "openLink": "Open link",
        "setCoverAttachment": "Use this attachment for the cover image"
      },
      "colorPalette": {
        "colorDropdown": "Color selector"
      },
      "confirm": {
        "deleteAttachment": {
          "text": "This action cannot be undone. The attachment will be permanently removed from the card.",
          "title": "Delete attachment?"
        },
        "deleteCard": {
          "text": "This action cannot be undone. All content of the card will be permanently removed.",
          "title": "Delete card?"
        },
        "deleteComment": {
          "text": "This action cannot be undone. The comment will be permanently removed from the card.",
          "title": "Delete comment?"
        },
        "deleteList": {
          "text": "This action cannot be undone. The list and all its cards will be permanently deleted.",
          "title": "Delete list?"
        },
        "removeMember": {
          "text": "The member will lose access to this pinboard and its cards.",
          "title": "Remove member?"
        }
      },
      "errors": {
        "boardUpdateFailed": "Error updating board",
        "cardLimitReached": "You can create a maximum of {limit} cards in this list.",
        "listLimitReached": "You can create a maximum of {limit} lists in this pinboard."
      },
      "flash": {
        "attachmentDeleted": "Attachment deleted",
        "boardUpdated": "Board updated",
        "cardNotFound": "Card not found",
        "colorUpdated": "Color updated",
        "commentDeleted": "Comment deleted",
        "commentUpdated": "Comment updated",
        "coverImageUpdated": "Cover image updated",
        "descriptionUpdated": "Description updated",
        "linkAdded": "Link added",
        "listRemoved": "List removed",
        "memberRemoved": "Member removed",
        "permissionsUpdated": "Permissions updated",
        "titleUpdated": "Title updated"
      },
      "headers": {
        "activities": "Activities",
        "attachFile": "Attach file",
        "attachLink": "Attach link",
        "members": "Members",
        "permissions": "Permissions",
        "pickColor": "Pick a color",
        "visitorPermissions": "Visitor can..."
      },
      "labels": {
        "activity": "Activity",
        "attachments": "Attachments",
        "cardTitle": "Card Title",
        "inList": "in {listName}",
        "visitorCanAddCards": "Delete and add cards",
        "visitorCanAddList": "Delete and add lists",
        "visitorCanComment": "Comment on cards",
        "visitorCanViewActivities": "View activity history"
      },
      "links": {
        "activities": "Activities",
        "boardMembers": "Members",
        "imageSearch": "Image Search"
      },
      "paragraphs": {
        "addMembers": "Invite members to this pinboard to manage it collaboratively. A fobizz account is needed for this.",
        "noMembers": "You have not invited any members to this pinboard yet.",
        "noMoreActivities": "No further activities"
      },
      "placeholders": {
        "cardName": "Enter card name...",
        "comment": "Post your comment...",
        "description": "Enter description...",
        "link": "Enter URL...",
        "listName": "Enter list name...",
        "searchImages": "Enter search term or color..."
      },
      "toolName": "Pinboard",
      "visitorPermissions": {
        "cardDescription": {
          "visitor_permissions_invisible": "Visitors cannot view this card",
          "visitor_permissions_read": "Visitors can view this card",
          "visitor_permissions_write": "Visitors can edit this card"
        },
        "listDescription": {
          "visitor_permissions_invisible": "Visitors cannot view this list",
          "visitor_permissions_read": "Visitors can view this list",
          "visitor_permissions_write": "Visitors can create cards"
        },
        "permissions": "Visitor permissions"
      }
    }
  }
}
